var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"us-fee"}},[_c('section',{staticClass:"fees"},[_c('h2',[_vm._v("Simple, convenient, safe and reliable, with no hidden fees.")])])])
}]

export { render, staticRenderFns }